import { CircleCheck, Stethoscope } from 'lucide-react';

import { availableSpecialtyIcons } from '../../utils/specialty-icons';

export default function SpecialtyCard({
  title,
  description,
  iconName,
  isSelected,
  onClick,
}: {
  title: string;
  description: string;
  iconName?: string;
  isSelected: boolean;
  onClick: () => void;
}) {
  const iconKey = iconName ?? title;

  return (
    <div
      onClick={onClick}
      className={`relative flex cursor-pointer items-center gap-4 rounded-2xl border bg-white p-4 shadow-sm transition-all duration-200 ease-in-out ${isSelected ? 'border-primary ring-primary/20 ring-2' : 'border-gray-200 hover:border-gray-300'} `}
    >
      {isSelected && (
        <div className="absolute -top-2 -left-2 flex h-6 w-6 items-center justify-center rounded-full bg-white">
          <CircleCheck className="text-primary h-7 w-7" />
        </div>
      )}

      <div className="bg-tertiary flex h-14 w-14 items-center justify-center rounded-full">
        {availableSpecialtyIcons.includes(iconKey) ? (
          <img
            src={`/specilities-icons/${iconKey}.svg`}
            alt={title}
            className="h-7 w-7 object-contain brightness-0 invert"
          />
        ) : (
          <Stethoscope className="h-7 w-7 text-white" />
        )}
      </div>
      <div className="w-4/5">
        <h3 className="text-lg font-bold text-gray-800">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
}
